export const PING = 'SL_PING'

export const ping = () => ({ type: PING })
